import React from 'react';
import { useI18n } from '../contexts/I18n';
import { useLanguage } from '../contexts/LanguageContext';
import { FaUsers, FaUserTie, FaMapMarkerAlt } from 'react-icons/fa';
import { marketingI18n } from '../content/homeMarketing';
import useScrollAnimate from '../hooks/useScrollAnimate';
import HowItWorksSection from './marketing/HowItWorksSection';
import MarketingPageIntro from './marketing/MarketingPageIntro';
import AboutShopsSection from './marketing/AboutShopsSection';
import BookingFlowDemo from './marketing/BookingFlowDemo';
import RatingFlowDemo from './marketing/RatingFlowDemo';
import './Home.css';
import './MarketingPages.css';
import './About.css';

const About = () => {
  const { t } = useI18n();
  const { lang } = useLanguage();
  const howT = marketingI18n[lang];
  useScrollAnimate([lang]);
  return (
    <div className="about-page" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      {/* Top Banner */}
      <section className="top-banner">
        <div className="container">
          <h1>{t('aboutHeroTitle') || 'Your Gateway to Beauty Excellence'}</h1>
          <p>{t('aboutHeroSub') || 'Discover, book, and experience the finest beauty services in your area'}</p>
        </div>
      </section>

      <MarketingPageIntro variant="about" page={howT.pages.about} lang={lang} layout="strip" />

      <HowItWorksSection t={howT} lang={lang} flatMobile />

      <AboutShopsSection lang={lang} />

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat">
              <div className="stat-icon"><FaUsers size={32} /></div>
              <div className="stat-number">10K+</div>
              <div className="stat-label">{t('happyCustomers') || 'Happy Customers'}</div>
            </div>
            <div className="stat">
              <div className="stat-icon"><FaUserTie size={32} /></div>
              <div className="stat-number">500+</div>
              <div className="stat-label">{t('beautyPros') || 'Beauty Professionals'}</div>
            </div>
            <div className="stat">
              <div className="stat-icon"><FaMapMarkerAlt size={32} /></div>
              <div className="stat-number">50+</div>
              <div className="stat-label">{t('citiesCovered') || 'Cities Covered'}</div>
            </div>
          </div>
        </div>
      </section>

      {/* Booking demo — calendar + time slots */}
      <section className="about-booking-demo-section" id="booking-demo">
        <div className="container">
          <div className="about-booking-demo-header scroll-animate from-bottom delay-1">
            <h2>{howT.howSteps[2].title}</h2>
            <p>{howT.howSteps[2].description}</p>
          </div>
          <div className="about-booking-demo-card scroll-animate from-bottom delay-2">
            <BookingFlowDemo lang={lang} featured />
          </div>
        </div>
      </section>

      {/* Rating demo — stars + discover slideshow */}
      <section className="about-rating-demo-section" id="rating-demo">
        <div className="container">
          <div className="about-rating-demo-header scroll-animate from-bottom delay-1">
            <h2>{howT.pages.about.highlights[3].title}</h2>
            <p>{howT.pages.about.highlights[3].desc}</p>
          </div>
          <div className="about-rating-demo-card scroll-animate from-bottom delay-2">
            <RatingFlowDemo lang={lang} featured />
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
